"use strict";

exports.__esModule = true;
exports.getDecoratedNode = getDecoratedNode;
exports.resolveRelativeDropNode = resolveRelativeDropNode;
/**
 * Resolve the innermost decorated react-dnd / HOC instance, then read its DOM node ref.
 * Replaces findDOMNode for React 18.
 */
function getDecoratedNode(component) {
  var current = component;
  while (current && typeof current.getDecoratedComponentInstance === "function") {
    var next = current.getDecoratedComponentInstance();
    if (!next || next === current) {
      break;
    }
    current = next;
  }
  if (!current) {
    return null;
  }
  if (typeof current.getNode === "function") {
    return current.getNode();
  }
  return current.node || null;
}

/**
 * Walk up from a node (or use it directly) looking for data-position="relative".
 */
function resolveRelativeDropNode(componentNode, pathLength) {
  var domNode = componentNode;
  if (pathLength > 0) {
    while (domNode != null && (!domNode.dataset || domNode.dataset.position !== "relative")) {
      domNode = domNode.parentElement;
    }
    domNode = domNode || componentNode;
  }
  if (domNode == null || !(domNode instanceof Element)) {
    return null;
  }
  return domNode;
}